import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SystemState } from "./state";

export const systemSelector = createFeatureSelector<SystemState>('system');
export const onlineSelector = createSelector(systemSelector, (state: SystemState) => state.online);